import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgPhoneRing = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M4.408 2.92a2.24 2.24 0 0 1 3.134 0l.006.006 2.627 2.627a2.227 2.227 0 0 1 0 3.123l-.047.05.039-.042a.714.714 0 0 0 0 1.017l.004.003 4.138 4.139a.74.74 0 0 0 1.033-.002 2.227 2.227 0 0 1 3.122 0l.002.003 2.645 2.618a2.24 2.24 0 0 1 0 3.133l-.012.012-.616.603a5.155 5.155 0 0 1-6.458.706l.182.112-.195-.12A40.7 40.7 0 0 1 3.097 10.02l-.01-.015a5.154 5.154 0 0 1 .706-6.458l.603-.616zm10.436 16.74a3.65 3.65 0 0 0 4.576-.509l.01-.01.614-.6a.74.74 0 0 0-.002-1.027l-2.63-2.602v-.001a.727.727 0 0 0-1.02 0l-.114.105.114-.103a2.24 2.24 0 0 1-3.134 0l-.006-.006-4.14-4.14a2.214 2.214 0 0 1-.003-3.146.727.727 0 0 0-.001-1.014L6.49 3.99a.74.74 0 0 0-1.029-.003l-.61.624a3.654 3.654 0 0 0-.509 4.575A39.2 39.2 0 0 0 14.844 19.66M14.25 4a.75.75 0 0 1 .75-.75A5.75 5.75 0 0 1 20.75 9a.75.75 0 0 1-1.5 0A4.25 4.25 0 0 0 15 4.75a.75.75 0 0 1-.75-.75m.511 3.093a.75.75 0 0 0 0 1.5.787.787 0 0 1 .787.787.75.75 0 0 0 1.5 0 2.287 2.287 0 0 0-2.287-2.287"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgPhoneRing;
